import ArtistGalleryInline from './ArtistGalleryInline';

export default ArtistGalleryInline;
